import { render, staticRenderFns } from "./ed-blank-whiteboard-users.vue?vue&type=template&id=4a69c451&scoped=true&"
import script from "./ed-blank-whiteboard-users.ts?vue&type=script&lang=ts&"
export * from "./ed-blank-whiteboard-users.ts?vue&type=script&lang=ts&"
import style0 from "./ed-blank-whiteboard-users.scss?vue&type=style&index=0&id=4a69c451&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a69c451",
  null
  
)

export default component.exports